export { SocoHttpModule } from '@app/soco/http/http_module';

// DSS Documentation on SocoHttpService - http://tiny.sc/cgsocohttpservice
export { SocoHttpService, SocoHttpServiceOptions } from '@app/soco/http/soco-http.service';
// DSS Documentation on SocoWebAuthService - http://tiny.sc/socowebauthservice
export { SocoWebAuthService } from '@app/soco/http/soco-web-auth.service';
